export const interceptorHelper = {
  config: async (config) => {
    const token = localStorage.getItem("qalort_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (process.env.NODE_ENV === "development") {
      // config.headers["ngrok-skip-browser-warning"] = "lol";
    }
    return config;
  },
  error: async (error) => {
    throw new Error(error);
  },
};
